import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
// import Dashboard from './pages/Dashboard';
import Login from './auth/Login';
import CheckAuth from './auth/CheckAuth';
import MainLayout from './navigation/MainLayout';
import Users from './pages/Users';
import NotFoundPage from './auth/NotFoundPage';
import ContactUs from './pages/ConatactUs';
import CustomerEmails from './pages/CustomerEmails';
import Prices from './pages/Prices';
import Jobs from './pages/Jobs';
import Applications from './pages/Applications';
import Commodity from './pages/Commodity';
import Orders from './pages/lpo/Orders';
import Vendor from './pages/Vendor';
import Handler from './pages/Handler';
import LpoTwoOrders from './pages/lpo/LpoTwoOrders';


//  --primary-green:#37713e;
//   --primary-yellow:#fece00;
//   --primary-blue: #352d80;

const theme = createTheme ({
	palette: {
		primary: {
			main: '#37713e',
			// light: '#352d80',
		},
		secondary: {
		    main: '#dc004e',
		},
		success: {
            light: '#4caf50',
            main: '#2e7d32',
            contrastText: '#fff',
		},
		info: {
            light: '#2196f3',
            main: '#1976d2',
            contrastText: '#fff',
		},

		background: {
            default: '#f5f5f5',
            paper: '#fff',
            blue:'#352d80'
		},
	},
});

function App() {
        return (
            <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <Routes>
                            <Route path="/" element={<Login />} />
                            {/* Protected Routes */}
                            <Route path="/*" element={
                                <MainLayout>
                                    <Routes>
                                        {/* Wrap all protected routes with CheckAuth */}
                                        <Route path="/users" element={ <CheckAuth> <Users /> </CheckAuth>} />
                                        <Route path="/customer-emails" element={<CheckAuth> <CustomerEmails /> </CheckAuth>} />
                                        <Route path="/prices" element={<CheckAuth> <Prices /> </CheckAuth>} />
                                        <Route path="/jobs" element={<CheckAuth> <Jobs /> </CheckAuth>} />
                                        <Route path="/commodity" element={<CheckAuth> <Commodity /> </CheckAuth>} />
                                        <Route path="/vendor" element={<CheckAuth> <Vendor /> </CheckAuth>} />
                                        <Route path="/lpo-orders" element={<CheckAuth> <Orders /> </CheckAuth>} />
                                        <Route path="/lpo-2-orders" element={<CheckAuth> <LpoTwoOrders /> </CheckAuth>} />
                                        <Route path="/handler" element={<CheckAuth> <Handler /> </CheckAuth>} />
                                        <Route path="/applications" element={<CheckAuth> <Applications /> </CheckAuth>} />
                                        <Route path="/contact-us" element={<CheckAuth> <ContactUs /> </CheckAuth>} />

                                        {/* 404 Page for unmatched routes */}
                                        <Route path="*" element={<NotFoundPage/>} />
                                    </Routes>
                                </MainLayout>
                            } />
                        </Routes>
                    </Router>
                </ThemeProvider>
            </SnackbarProvider>
        );
}

export default App;